import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Widget } from '~/components/MyWorkspace/Widget';
//import { TaskStatusEnum } from '~/services/Http/client.people.generated';
import { useSelectedLanguageContext } from '~/components/SelectedLanguage';
import { TaskStatusEnum } from '~/services/Http/client.people.generated';
import { useGetEmployeeAssignedWorklists } from '~/services/Http/hooks';

import { WidgetProps } from '../../data/widgets';

import { MyWorklistsWidgetComponent } from './components/MyWorklistsWidgetComponent';
import { useSxStyles } from './useStyles';

export interface Props extends WidgetProps {}

export const getEmployeeAssignedWorklistsReqParams = {
  employeeId: 'me',
  statuses: [
    TaskStatusEnum.NEW,
    TaskStatusEnum.IN_PROGRESS,
    TaskStatusEnum.SKIPPED,
  ],
};

export const MyWorklistsWidget: React.FC<Props> = ({ title }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const { language } = useSelectedLanguageContext();

  const {
    data: worklistData,
    loading,
    failedToLoad,
    mutate: mutateMyWorklists,
  } = useGetEmployeeAssignedWorklists({
    ...getEmployeeAssignedWorklistsReqParams,
    lang: language,
  });

  return (
    <Widget
      title={t('myTasklists')}
      content={
        <MyWorklistsWidgetComponent
          worklistData={worklistData}
          isLoading={loading}
          failedToLoad={failedToLoad}
          mutateMyWorklists={mutateMyWorklists}
        />
      }
      customSxStyles={{ actions: sxStyles.widgetActions }}
      dataCy="my-worklists-widget"
    />
  );
};
